'use strict';

function Picture() {
  this.declaredClass = null;
  this.node = null;
  this.id = null;

  this.init = function () {
    if (typeof picturefill === 'function') picturefill(); // IE11 pollyfil
  };
  this.initAllReady = function () {
    $(this.node).show();
  };

  this.destroy = function () {};
}